import { SxProps } from "@mui/material";
import AddCircleOutlineRoundedIcon from "@mui/icons-material/AddCircleOutlineRounded";
import StyledButtonV2 from "../../../../../../../../components/app/StyledButtonV2";

interface StyleAddButtonProps {
  onClick: (e: any) => void;
  label: string;
  w?: string;
  disableStartIcon?: boolean;
  centerLabel?: boolean;
}

export const StyleAddButton = ({
  onClick,
  label,
  w,
  disableStartIcon,
  centerLabel,
  ...others
}: StyleAddButtonProps & SxProps & { centerLabel?: boolean }) => (
  <StyledButtonV2
    sx={{
      minWidth: w ?? "100%",
      display: "flex",
      justifyContent: centerLabel ? "center" : "start",
      ...others,
    }}
    variant="outlined"
    style={{ color: "#1A1A1A99", backgroundColor: "#1A1A1A0D" }}
    sIcon={!disableStartIcon && <AddCircleOutlineRoundedIcon />}
    size="small"
    label={label}
    onClick={(e) => onClick(e)}
  />
);
